$(document).ready(function() {
  // $('.popup-memberlogin').click(function(event){
  //     let formEmbed = document.querySelector(`section[name="sign-in-with-shop-provider"] shop-login-button`);
      
  //     if (formEmbed && formEmbed.shadowRoot) {
  //       let variantImages = formEmbed.shadowRoot.querySelector("shop-login-default");
  //       let popupaccount = variantImages.shadowRoot.querySelector("login-with-shop-button");
  //       console.log(popupaccount);
  //       popupaccount.click();
  //     } 
  //     event.preventDefault();
  //   });
  
  // let formEmbed = document.querySelector(`.login section[name="sign-in-with-shop-provider"] shop-login-button`);
  // let shopEmbed = document.querySelector(`[data-nametag="shop-portal-provider"]`);
  // let shopEmbed1 = shopEmbed.shadowRoot.querySelector(`shop-sheet-modal`);
  // let shopEmbed2 = shopEmbed1.shadowRoot.querySelector(`.sda-overlay`);
  // let shopEmbed3 = shopEmbed1.shadowRoot.querySelector(`.sda-modal`);
  // shopEmbed2.style.pointerEvents = "none";
  // shopEmbed3.style.pointerEvents = "all";
  // if (formEmbed && formEmbed.shadowRoot) {
  //   let variantImages = formEmbed.shadowRoot.querySelector("shop-login-default");
  //   let popupaccount = variantImages.shadowRoot.querySelector("login-with-shop-button");
  //   popupaccount?.addEventListener('click', () => {
  //     // navigator.userAgent.indexOf('Safari') !== -1
  //     document.documentElement.classList.add('add-tranform');
  //   })
  // }
  // shopEmbed2?.addEventListener('click', () => {
  //   document.documentElement.classList.remove('add-tranform');
  // })
  const emailInput = document.querySelector('.footersubscripationfiledinput');
  const messagefooter = document.getElementById('messagefootersubscribed');   
  
  if (emailInput.value) {
    messagefooter.style.display = 'flex';
  }
  else{
    messagefooter.style.display = 'none';
  }
});


  
